import React from 'react'
import Rating from 'react-rating'
import StarIcon from '@icons/star/active'
import EmptyStarIcon from '@icons/star/inactive'
import SVG from 'react-inlinesvg'

const Star = <SVG className="rating__star" src={StarIcon} />
const EmptyStar = <SVG className="rating__star" src={EmptyStarIcon} />

const RatingInput = ({ id, error, value, onChange, className, ...props }) => {
  return (
    <div className="rating">
      <Rating
        id={id}
        initialRating={value}
        onChange={onChange}
        emptySymbol={EmptyStar}
        fullSymbol={Star}
        {...props}
      />
    </div>
  );
};

export default RatingInput
